export default __webpack_public_path__ + "static/media/certification7.e68ec63c.jpg";